import {
  apiUrl,
  getList,
  getSingleRecord,
  saveRecord,
  deleteRecord,
  getStatsData,
  getAll,
  putAction,
  deleteAction,
  getAuditData,
  postAction,
  get,
  upload,
  exportData,
} from './apiUtils';
import type { ApiListParamsWithUnderscores, ApiExportParams } from '../types/api/listParams';
import type { ListApiResponse } from '../types/apiResponse';
import type { Stats } from '../types/stats';

const baseUrl = apiUrl + '/keyProviders/';

export function getAllKeyProviders(): Promise<unknown> {
  return getAll(baseUrl);
}

export function getKeyProviders(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}search`, params);
}

export function getKeyProviderById(id: string): Promise<unknown> {
  return getSingleRecord(baseUrl, id);
}

export function saveKeyProvider(keyProvider: unknown): Promise<unknown> {
  return upload(baseUrl, keyProvider);
}

export function deleteKeyProvider(id: string): Promise<unknown> {
  return deleteRecord(baseUrl, id);
}

export function getStats(id: string): Promise<Stats> {
  return getStatsData(baseUrl, id);
}

export function getStatsByDay(id: string): Promise<unknown> {
  return get(`${baseUrl}${id}/statsByDay/`);
}

export function getAggregateStats(
  id: string,
  from: Date,
  to: Date
): Promise<unknown> {
  const fromStr = from.toISOString().split('T')[0];
  const toStr = to.toISOString().split('T')[0];
  return get(
    `${baseUrl}${id}/aggregateStats?fromDate=${fromStr}&toDate=${toStr}`
  );
}

export function getAudit(id: string): Promise<unknown> {
  return getAuditData(baseUrl, id);
}

export function addAudit(id: string, comment: string): Promise<unknown> {
  return postAction(`${baseUrl}${id}/audit`, { comment });
}

export function getKeyProviderRequestInformation(id: string): Promise<unknown> {
  return getAll(`${baseUrl}${id}/requestinformation`);
}

export function saveKeyProviderRequestInformation(
  id: string,
  requestInformation: unknown
): Promise<unknown> {
  return putAction(`${baseUrl}${id}/requestinformation`, requestInformation);
}

export function getKeyProviderPromotionSetting(id: string): Promise<unknown> {
  return get(`${baseUrl}${id}/promotionsetting`);
}

export function saveKeyProviderPromotionSetting(
  id: string,
  promotionSetting: unknown
): Promise<unknown> {
  return putAction(`${baseUrl}${id}/promotionsetting`, promotionSetting);
}

export function getPlatformsForKeyProvider(id: string): Promise<unknown> {
  return getAll(`${baseUrl}${id}/platforms`);
}

export function saveKeyProviderPlatform(
  keyProviderId: string,
  platformId: string
): Promise<unknown> {
  return saveRecord(`${baseUrl}${keyProviderId}/platform/`, { platformId });
}

export function deleteKeyProviderPlatform(
  keyProviderId: string,
  platformId: string
): Promise<unknown> {
  return deleteAction(`${baseUrl}${keyProviderId}/platform/${platformId}`);
}

export function exportKeyProviderData(params: ApiExportParams): Promise<void> {
  return exportData(`${apiUrl}/export/keyProviders/search`, 'name', params);
}
